import { Trans } from '@lingui/react';
import { Button } from '@startuptools/ui/Button';
import { Card } from '@startuptools/ui/Card';
import { FormControl } from '@startuptools/ui/FormControl';
import { FormLabel } from '@startuptools/ui/FormLabel';
import { Input } from '@startuptools/ui/Input';
import { Snackbar } from '@startuptools/ui/Snackbar';
import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import { Suspense, useState } from 'react';
import { useCompanySetProfileMutation, useCompanySuspenseQuery } from '../../graphql/react-operations';
import { type SubmitHandler, useForm } from 'react-hook-form';
import { useCompanyId } from '@startuptools/common/react-wrapper';

type FormValues = {
  email?: string | null;
  web?: string | null;
};

const CompanyProfileInner = () => {
  const [showSnackbar, setShowSnackbar] = useState(false);
  const companyId = useCompanyId();
  const {
    data: { company },
  } = useCompanySuspenseQuery({ variables: { id: companyId } });
  const [doSave, { loading }] = useCompanySetProfileMutation();

  const { register, handleSubmit } = useForm<FormValues>({ defaultValues: { email: company.email, web: company.web } });

  const onSubmit: SubmitHandler<FormValues> = async ({ email, web }) => {
    await doSave({ variables: { companyId, input: { email, web } } });
    setShowSnackbar(true);
  };

  return (
    <>
      <Stack gap={3}>
        <Typography level="h2">
          <Trans id="Company Profile" />
        </Typography>
        <Card>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Stack gap={3} maxWidth={500}>
              <FormControl>
                <FormLabel>
                  <Trans id="Email" />
                </FormLabel>
                <Input {...register('email')} type="email" placeholder="name@example.com" />
              </FormControl>
              <FormControl>
                <FormLabel>
                  <Trans id="Website" />
                </FormLabel>
                <Input {...register('web')} type="text" placeholder="https://example.com" />
              </FormControl>
              <Button loading={loading} type="submit">
                <Trans id="Save" />
              </Button>
            </Stack>
          </form>
        </Card>
      </Stack>
      <Snackbar open={showSnackbar} onClose={() => setShowSnackbar(false)} variant="solid" color="success">
        <Trans id="Profile was saved successfully" />
      </Snackbar>
    </>
  );
};

export const CompanyProfile = () => {
  return (
    <Suspense>
      <CompanyProfileInner />
    </Suspense>
  );
};
